<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text extended color="white" extension-height="94px">
                <v-toolbar-title style="width: 60%;">
                    <v-layout flex wrap>
                        <v-flex xs5>
                            Заказ №{{ order.id }}
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
							<span class="booking-date">
								{{ order.updated_at | formatDate }}
							</span>
                            <span class="booking-time">
								{{ order.updated_at | formatTime }}
							</span>
                        </v-flex>
                    </v-layout>
                </v-toolbar-title>

                <v-spacer/>

                <v-btn icon :loading="loading" :disabled="loading" @click="sendForm">
                    <v-icon>print</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>

                <div slot="extension" class="w-100 action-btn">
                    <v-btn color="info" @click="confirmRejectOrder(order.id, 4)"
                           :disabled="(order.state < 1 || order.state > 3) && order.state < 9">Готовится
                    </v-btn>

                    <v-btn color="info" @click="confirmRejectOrder(order.id, 5)" :disabled="order.state !== 4"
                           v-if="order.delivery === 1">
                        Готов
                    </v-btn>

                    <v-btn color="info" @click="confirmRejectOrder(order.id, 6)" :disabled="order.state !== 4"
                           v-if="order.delivery === 2">
                        В пути
                    </v-btn>

                    <v-btn color="success" @click="showDialog(order.id, 7)"
                           :disabled="order.state < 5 || order.state === 9" v-if="order.delivery === 2">
                        Доставлен
                    </v-btn>

                    <v-btn color="success" @click="showDialog(order.id, 8)"
                           :disabled="order.state < 5 || order.state === 9" v-if="order.delivery === 1">
                        {{ order.state === 8 ? 'Завершён' : 'Завершить' }}
                    </v-btn>

                    <v-btn color="error" @click="showDialog(order.id, -1)"
                           :disabled="order.state > 6 && order.state < 9">
                        {{ order.state > 0 ? 'Отменить' : 'Отменён' }}
                    </v-btn>
                </div>
            </v-toolbar>

            <v-form class="form-add form-add--extended">
                <v-layout flex wrap>
                    <v-flex xs7>
                        <v-card text class="mt-3">
                            <v-toolbar text color="white">
                                <v-toolbar-title>Состав заказа</v-toolbar-title>
                            </v-toolbar>

                            <v-list two-line style="height:510px;padding:0;overflow-x:scroll;" class="order-details">

                                <template v-for="item in details">
                                    <v-list-item
                                        :key="item.title"
                                        avatar
                                        class="order-list">
                                        <v-list-item-avatar tile>
                                            <img :src="rootURL + item.img" alt="">
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.name"></v-list-item-title>

                                            <v-list-item-subtitle class="order-extra">
                                                <i v-for="attr in item.extra" :key="Math.random()">{{ attr.attr }}</i>
                                                <i v-for="attr in item.variant" :key="Math.random()">
                                                    {{ attr.label }}
                                                </i>
                                            </v-list-item-subtitle>

                                            <v-list-item-subtitle v-if="item.variant && item.variant.length">
                                                {{ item.variant[0].value | formatPrice }} сум x {{ item.count }} шт
                                            </v-list-item-subtitle>

                                            <v-list-item-subtitle v-else>
                                                Продукты: {{ item.price - item.delivery_price | formatPrice }} сум x
                                                {{ item.count }} шт
                                                <template v-if="item.delivery_price">
                                                    <br>
                                                    Упаковка: {{ item.delivery_price | formatPrice }} сум x
                                                    {{ item.count }} шт
                                                    <br><br>
                                                    Итого: {{ item.price | formatPrice }} сум x {{ item.count }} шт
                                                </template>
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-card>

                        <v-card v-if="order.coords" text class="mt-3">
                            <v-toolbar text color="white">
                                <v-toolbar-title>Локация</v-toolbar-title>
                            </v-toolbar>

                            <yandex-map
                                :coords="order.coords"
                                :zoom="16"
                            >
                                <ymap-marker
                                    :coords="order.coords"
                                    marker-id="123"
                                />
                            </yandex-map>
                        </v-card>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs4>
                        <v-layout flex wrap>
                            <v-flex xs12 class="mb-2 mt-2">
                                <v-subheader class="pa-0 v-subheader--small">Пользователь</v-subheader>
                                <span>{{ order.customer }}</span>
                            </v-flex>

                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Номер телефона</v-subheader>
                                <span>{{ order.phone | formatPhone }}</span>
                            </v-flex>

                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Адрес доставки</v-subheader>
                                <span>{{ order.address }}</span>
                            </v-flex>

                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Платформа</v-subheader>
                                <span>{{ order.platform | formatPlatform }}</span>
                            </v-flex>

                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Способ доставки</v-subheader>
                                <span>{{ order.delivery | formatDelivery }}</span>
                            </v-flex>

                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Сумма чека</v-subheader>
                                <span>{{ calculatePrice(order) | formatPrice }} сум</span>
                            </v-flex>

                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Способ оплаты</v-subheader>
                                <span>{{ order.payment | formatPayment }}</span>
                            </v-flex>

                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">{{ generatePaymentText(order) }}
                                </v-subheader>
                                <span>{{ order.price | formatPrice }} сум</span>
                            </v-flex>
                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Оплачено бонусами</v-subheader>
                                <span>{{ calculateBonusPayment(order) | formatPrice }}</span>
                            </v-flex>
                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Бонусы за заказ</v-subheader>
                                <span v-if="order.customer_id > 0">{{ calculateBonus(order) | formatPrice }}</span>
                                <span v-else>0</span>
                            </v-flex>
                            <v-flex xs12 class="mb-2">
                                <v-subheader class="pa-0 v-subheader--small">Комментарий</v-subheader>
                                <span>{{ order.comment }}</span>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>

            <v-dialog v-model="dialog.show" persistent max-width="350px">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Заказ будет {{ `${dialog.state < 0 ? 'отменён' : 'завершён'}` }}!</h4>
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="info" class="v-btn--save" @click="confirmRejectOrder(dialog.id, dialog.state)">
                            Продолжить
                        </v-btn>
                        <v-btn color="error" class="v-btn--save" @click="dialog.show = false">
                            Отменить
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
import config from '../../../config'
import Order from '../../../api/order'
import Loader from '../../../components/Loader/Layout'
import {mapGetters} from 'vuex'

export default {
    name: 'editOrder',
    props: ['orderId'],
    components: {
        Loader
    },
    data: () => ({
        loading: false,
        loader: false,
        order: {
            id: 0,
            order_id: 0,
            customer_id: 0,
            customer: '',
            payment: 0,
            delivery: 0,
            address: '',
            comment: '',
            phone: '+998901234567',
            created_at: '',
            updated_at: '',
            state: 0,
            platform: 0,
            price: 0,
            price_without_bonus: null
        },
        details: [],
        rootURL: '',
        dialog: {
            show: false,
            title: '',
            state: 0,
            id: 0
        }
    }),
    mounted() {
        this.rootURL = config.rootPath
        this.getOrder(this.orderId)
        this.getDetails(this.orderId)
    },
    methods: {
        getOrder(id) {
            this.loader = true

            Order
                .getById(id)
                .then(response => this.order = response.data.data)
                .catch(error => this.$store.commit('showSnackbar', {text: error.response.data.error[Object.keys(error.response.data.error)[0]][0]}))
                .finally(() => this.loader = false)
        },

        getDetails(id) {
            Order
                .getDetails(id)
                .then(response => this.details = response.data.data)
                .catch(error => new Error(error))
        },

        calculateBonus(order) {
            let bonus = 0

            if (order.price_without_bonus === 0) {
                const project = this.getProject
                bonus = parseInt(order.price * (project.bonus / 100))
            }

            return bonus
        },

        calculatePrice(order) {
            let price = 0

            if (order.price === 0) {
                price = order.price_without_bonus
            } else if (order.price_without_bonus > 0 && order.price > 0) {
                if (order.price_without_bonus > order.price) {
                    price = (order.price_without_bonus - order.price) + order.price
                } else {
                    price = (order.price - order.price_without_bonus) + order.price
                }
            } else {
                price = order.price
            }

            return price * 1
        },

        calculateBonusPayment(order) {
            let payment = 0

            if (order.price_without_bonus > 0) {
                if (order.price_without_bonus > order.price) {
                    payment = order.price_without_bonus - order.price
                } else {
                    payment = order.price - order.price_without_bonus
                }
            }

            return payment
        },
        confirmRejectOrder(id, state) {
            this.loading = true
            this.dialog = {
                id: 0,
                state: 0,
                title: '',
                show: false
            }

            Order
                .edit({
                    id,
                    state
                })
                .then(response => {
                    this.order = response.data.data
                    this.$store.commit('showSnackbar', {
                        text: 'Статус заказа изменен успешно',
                        color: 'success'
                    })
                    this.$store.commit('changeOrderState', {
                        id,
                        state
                    })
                })
                .catch(error => this.$store.commit('showSnackbar', {text: error.response.data.error[Object.keys(error.response.data.error)[0]][0]}))
                .finally(() => {
                    Order
                        .getBadges()
                        .then(response => this.$store.commit('changeBadgesState', response.data.data))
                        .catch(error => new Error(error))
                        .finally(() => this.loading = false)
                })
        },
        sendForm() {
            this.$router.push({name: 'ordersRoot'})
        },
        showDialog(id, state) {
            this.dialog.id = id
            this.dialog.show = true
            this.dialog.state = state
        },
        generatePaymentText(order) {
            if (order.payment === 3 || order.payment === 2) {
                return 'Оплачено'
            } else {
                if (order.state > 6 && order.state < 9) {
                    return 'Оплачено'
                } else {
                    return 'К оплате'
                }
            }
        }
    },
    computed: {
        ...mapGetters(['getProject'])
    },

    beforeRouteLeave(to, from, next) {
        next()
    },
    beforeRouteUpdate(to, from, next) {
        this.order = this.getOrder(to.params.orderId)
        this.details = this.getDetails(to.params.orderId)
        next()
    }
}
</script>

<style lang="scss">
@import "../../../assets/styles/fonts.scss";
@import "../../../assets/styles/colors.scss";

.booking {
    &-date,
    &-time {
        display: block;
        font: 400 0.9375rem / 22px $fontFamily;
    }

    &-guest-count {
        &_content {
            width: 20px;
            margin: 0 10px;
            text-align: center;
            display: inline-block;
        }
    }
}

.order {
    &-list {
        //padding: 10px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);

        &:first-child {
            border-top: 1px solid rgba(0, 0, 0, 0.2);
        }
    }

    &-extra {
        i {
            color: $orderAttr;
        }
    }
}

.ymap-container {
    height: 400px;
    margin-bottom: 25px;
}
</style>
